(function () {
  class PlugHeaderDrawer extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        toggleButton: this.querySelector('.plug-header-drawer__toggle-btn'),
        closeButton: this.querySelector('.plug-header-drawer__close-btn'),
        drawerMenu: this.querySelector('.plug-header-drawer__inner')
      };

      this.setupEventHandlers();
    }

    setupEventHandlers() {
      this.elements.toggleButton.addEventListener('click', () => {
        return this.isOpen() ? this.close() : this.open();
      });

      this.elements.closeButton.addEventListener('click', () => {
        return this.close();
      });

      const menuItems = this.elements.drawerMenu.querySelectorAll('.plug-header-drawer__list-menu-item');
      menuItems.forEach((menuItem) => {
        const l2Menu = menuItem.querySelector('.plug-header-drawer__l2-menu');
        if (!l2Menu) return;
        const l1Button = menuItem.querySelector('.plug-header-drawer__l1-menu-btn');
        l1Button.addEventListener('click', () => {
          if (this.l2MenuIsOpen(l2Menu)) {
            l1Button.classList.remove('is-open');
            this.closeL2Menu(l2Menu);
          } else {
            l1Button.classList.add('is-open');
            this.openL2Menu(l2Menu);
          }
        });
      });
    }

    isOpen() {
      return this.dataset.open === 'true';
    }

    close() {
      if (this.isOpen()) {
        document.body.classList.remove('js-drawer-open');
        document.getElementsByTagName('html')[0].classList.remove('js-drawer-open');
        this.dataset.open = 'false';

        setTimeout(() => {
          this.elements.drawerMenu.style.transitionDuration = '';
          this.elements.drawerMenu.classList.add('hidden');
        }, 450);
      }
    }

    open() {
      if (!this.isOpen()) {
        this.elements.drawerMenu.classList.remove('hidden');
        window.requestAnimationFrame(() => {
          setTimeout(() => {
            document.getElementsByTagName('html')[0].classList.add('js-drawer-open');
            document.body.classList.add('js-drawer-open');
            this.dataset.open = 'true';

            window.requestAnimationFrame(() => {
              setTimeout(() => {
                this.elements.drawerMenu.style.transitionDuration = '450ms';
              }, 300);
            });
          }, 0);
        });
      }
    }

    l2MenuIsOpen(l2Menu) {
      return l2Menu.classList.contains('is-open');
    }

    openL2Menu(l2Menu) {
      this.getHeightOfHiddenList(l2Menu, (height, err) => {
        if (err) throw err;
        l2Menu.style.display = 'block';
        window.requestAnimationFrame(() => {
          setTimeout(() => {
            l2Menu.style.height = `${height}px`;
            l2Menu.classList.add('is-open');
          }, 0);
        });
      });
    }

    closeL2Menu(l2Menu) {
      l2Menu.style.height = '';
      l2Menu.classList.remove('is-open');
      l2Menu.classList.add('fast-fade');

      window.requestAnimationFrame(() => {
        setTimeout(() => {
          l2Menu.style.display = '';
          l2Menu.classList.remove('fast-fade');
        }, 300);
      });
    }

    getHeightOfHiddenList(list, cb) {
      try {
        const clone = list.cloneNode(true);
        clone.style.opacity = '0';
        clone.style.display = 'block';
        clone.style.position = 'absolute';
        clone.style.left = '0';
        clone.style.top = '0';
        clone.style.right = '0';
        clone.style.width = '100%';
        clone.style.height = 'auto';
        list.parentElement.appendChild(clone);
        window.requestAnimationFrame(() => {
          setTimeout(() => {
            const height = clone.getBoundingClientRect().height;
            list.parentElement.removeChild(clone);
            console.log({height});
            return cb(height);
          }, 0);
        });
      } catch (exception) {
        return cb(undefined, exception);
      }
    }
  }

  customElements.define('plug-header-drawer', PlugHeaderDrawer);
})();
